import { clearStoredAuth } from "../lib/auth.ts";

/** Route-local sign-out affordance for staff topbars. Replaces the old globally
 *  fixed floating button so it never overlaps mobile content. Clears stored auth
 *  and reloads the role's root, which re-triggers AuthGate's entry screen. */
export function SignOutButton({
  redirectTo,
  className = "btn ghost sm",
}: {
  redirectTo: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={className}
      data-testid="auth-signout"
      onClick={() => {
        clearStoredAuth();
        window.location.assign(redirectTo);
      }}
    >
      Sign out
    </button>
  );
}
